<div class="app-layout graph-fullscreen-mode">
  <main class="workspace workspace-link-analysis workspace-graph-fullscreen">
      <div class="link-analysis-viewer-shell graph-fullscreen-active">
      <app-link-analysis-graph-dashboard
        class="link-analysis-dashboard"
        [investigation]="investigation"
        [graphPayload]="graphPayload"
        [loading]="showGraphLoader"
        [loadingMessage]="resultLoadingMessage"
        [backgroundProcessing]="showBackgroundProgress"
        [backgroundProcessingMessage]="autoExpansionProgressMessage"
        [errorMessage]="!loading && investigation?.status === 'failed' ? errorMessage : ''"
        [nodeActions]="dashboardNodeActions"
        [selectedActionKeys]="dashboardSelectedActionKeys"
        [actionRadioGroupName]="collectionRadioGroupName"
        [showSearchPanel]="showInspectorSearchPanel"
        [searchAvailabilityLabel]="selectedActionAvailabilityLabel"
        [showSearchValuePicker]="dashboardShowSearchValuePicker"
        [searchValueOptions]="dashboardSearchValueOptions"
        [selectedSearchValues]="dashboardSelectedSearchValues"
        [searchableValueRows]="selectedSearchableValueRows"
        [showStarterSearch]="dashboardShowStarterSearch"
        [starterQueryType]="starterQueryType"
        [starterQueryValue]="starterQueryValue"
        [starterActionRunning]="isStarterActionRunning"
        [canRunAi]="selectedCanRunAi"
        [aiRunning]="isAiActionRunning"
        [showBackButton]="true"
        [graphFullscreenOpen]="graphFullscreenOpen"
        [showStopAutomation]="showStopAutomation"
        [stoppingAutomation]="stoppingAutomation"
        (back)="goBack()"
        (regenerate)="regenerate()"
        (stopAutomation)="stopAutomation()"
        (nodeSelect)="onDashboardNodeSelect($event)"
        (addNodeRequested)="openManualNode()"
        (jumpToSourceValue)="onAggregateEntryJump($event)"
        (searchValueSelect)="setCollectionValueSelected($event.value, $event.selected)"
        (actionKeySelect)="setNodeActionKeySelected($event.key, $event.selected)"
        (runSelectedAction)="runDashboardSelectedAction()"
        (starterQueryTypeSelect)="chooseStarterType($event)"
        (starterQueryValueChange)="starterQueryValue = $event"
        (runStarterSearch)="runStarterAction()"
        (runAction)="runSelectedNodeAction($event)"
        (prepareDetailFieldSearch)="onPrepareDetailFieldSearch($event)"
        (clearDetailFieldSearch)="onClearDetailFieldSearch()"
        (runAi)="runAiAnalysis()"
        (galleryUpdated)="onGraphGalleryUpdated()"
      ></app-link-analysis-graph-dashboard>
    </div>
  </main>
</div>

<div class="manual-node-backdrop" *ngIf="manualNodeOpen" (click)="closeManualNode()">
  <section class="manual-node-dialog" role="dialog" aria-modal="true" aria-labelledby="manual-node-title" (click)="$event.stopPropagation()" (keydown.escape)="closeManualNode()">
    <header><div><h2 id="manual-node-title">Add node</h2><p>Enter the details to connect a node directly to the investigation root.</p></div>
      <button type="button" aria-label="Close add node" (click)="closeManualNode()" [disabled]="manualNodeSaving">×</button></header>
    <form #manualForm="ngForm" (ngSubmit)="saveManualNode()">
      <fieldset [disabled]="manualNodeSaving">
        <div class="manual-node-fields">
          <label>Service name *<input name="manualLabel" [(ngModel)]="manualNodeDraft.label" required maxlength="160" autofocus /></label>
          <label>Node type<select name="manualType" [(ngModel)]="manualNodeDraft.type"><option value="person">Person</option><option value="phone">Phone</option><option value="email">Email</option><option value="username">Username</option><option value="website">Website / service</option></select></label>
          <label>Name<input name="manualName" [(ngModel)]="manualNodeDraft.name" maxlength="200" /></label>
          <label>Phone<input name="manualPhone" [(ngModel)]="manualNodeDraft.phone" maxlength="80" /></label>
          <label>Email<input name="manualEmail" [(ngModel)]="manualNodeDraft.email" type="email" email maxlength="254" /></label>
          <label>Username<input name="manualUsername" [(ngModel)]="manualNodeDraft.username" maxlength="160" /></label>
          <label>Image URL<input name="manualImage" [(ngModel)]="manualNodeDraft.image_url" type="url" pattern="https?://.+" maxlength="2048" /></label>
          <label>Profile / website URL<input name="manualProfile" [(ngModel)]="manualNodeDraft.profile_url" type="url" pattern="https?://.+" maxlength="2048" /></label>
        </div>
        <label>Notes<textarea name="manualNotes" [(ngModel)]="manualNodeDraft.notes" rows="3" maxlength="4000"></textarea></label>
        <div class="manual-node-custom" *ngFor="let detail of manualNodeDraft.details; let i = index">
          <label>Field label<input [name]="'manualKey'+i" [(ngModel)]="detail.label" required maxlength="80" /></label>
          <label>Value<input [name]="'manualValue'+i" [(ngModel)]="detail.value" required maxlength="2000" /></label>
          <button type="button" [attr.aria-label]="'Remove field '+(i+1)" (click)="manualNodeDraft.details.splice(i,1)">Remove</button>
        </div>
        <button type="button" (click)="manualNodeDraft.details.push({label:'',value:''})" [disabled]="manualNodeDraft.details.length >= 30">+ Add detail field</button>
      </fieldset>
      <p class="manual-node-error" *ngIf="manualNodeError" role="alert">{{ manualNodeError }}</p>
      <footer><button type="button" (click)="closeManualNode()" [disabled]="manualNodeSaving">Cancel</button>
        <button type="submit" class="manual-node-submit" [disabled]="manualForm.invalid || !manualNodeDraft.label.trim() || manualNodeSaving">{{ manualNodeSaving ? 'Adding…' : 'Add node' }}</button></footer>
    </form>
  </section>
</div>
